// CAN Bus Load Calculator tool: display constants + row-shape helpers only. Per this
// tool's requirement, ALL calculation and validation logic lives server-side (see
// src/lib/toolsApi.js canBusLoadToolApi and backend/tools/can_bus_load_tool.py) — unlike
// other tool lib files, this one deliberately does NOT mirror validation client-side;
// field errors shown in the UI come straight from the backend response.

let _rowSeq = 0;
export function nextRowId() {
  _rowSeq += 1;
  return `row-${Date.now()}-${_rowSeq}`;
}

export const BIT_RATE_PRESETS = [
  { value: 125000, label: '125 kbps' },
  { value: 250000, label: '250 kbps' },
  { value: 500000, label: '500 kbps' },
  { value: 1000000, label: '1 Mbps' },
];

export const DEFAULT_BIT_RATE_BPS = 500000;

export const PERIOD_PRESETS_MS = [2, 5, 10, 20, 50, 100, 1000, 2000];

export const FRAME_TYPES = [
  { value: 'standard', label: 'Standard (11-bit)' },
  { value: 'extended', label: 'Extended (29-bit)' },
];

export const DLC_OPTIONS = [0, 1, 2, 3, 4, 5, 6, 7, 8];

export function makeRow(overrides = {}) {
  return {
    id: nextRowId(),
    name: '',
    canIdHex: '',
    frameType: 'standard',
    dlc: 8,
    periodMs: 100,
    periodIsCustom: false,
    ...overrides,
  };
}

export const DEFAULT_ROWS = [
  makeRow({ name: 'EngineSpeed', canIdHex: '100', dlc: 8, periodMs: 10 }),
  makeRow({ name: 'VehicleSpeed', canIdHex: '200', dlc: 8, periodMs: 20 }),
  makeRow({ name: 'BodyStatus', canIdHex: '300', dlc: 4, periodMs: 100 }),
];

export const STATUS_STYLES = {
  green: { text: 'text-emerald-600', ring: 'ring-emerald-500/30', bar: 'bg-emerald-500', label: 'Comfortable Margin' },
  yellow: { text: 'text-amber-600', ring: 'ring-amber-500/30', bar: 'bg-amber-500', label: 'Monitor' },
  red: { text: 'text-destructive', ring: 'ring-destructive/30', bar: 'bg-destructive', label: 'Design Risk' },
};
